import React from "react";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";

interface OptionSelectorProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: { value: string; label: string }[];
}

const OptionSelector: React.FC<OptionSelectorProps> = ({
  value,
  onChange,
  options,
}) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup value={value} onChange={onChange}>
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<Radio size="small" />}
            label={opt.label}
            sx={{
              '& .MuiFormControlLabel-label': {
                color: 'rgba(110, 112, 121, 1)',
                fontFamily: 'Inter',
                fontWeight: 500,
                fontSize: '12px',
                lineHeight: '10px',
              },
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default OptionSelector;